import { useCampaign } from "@/components/apis/campaign";
import Timeline from "@/components/campaign/timeline";
import Image from "@/components/Image";
import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";

export default function CampaignDetail() {
    const { id } = useParams<{ id: string }>();
    const { data } = useCampaign()

    const dataDetail = useMemo(() => {
        return data?.find((item) => item.id === Number(id));
    }, [data, id]);

    const content = useMemo(() => {
        return dataDetail?.content || ""
    }, [dataDetail?.content]);

    return (
        <div className="mx-4 mb-10 text-white  mt-20">
            <h2 className="text-[28px] font-medium">{dataDetail?.title}</h2>
            <div className="my-6" dangerouslySetInnerHTML={{ __html: content || "" }}></div>
            <div>
                <Image
                    src={dataDetail?.mobileBackground ?? ""}
                    height={878}
                    width={564}
                    alt=""
                    className="w-full rounded-xl h-[453px] object-cover"
                />
            </div>
            <div className="mt-8 ">
                <Timeline timeLine={dataDetail?.timeLine ?? []} />
            </div>
            <div className="mt-8 mx-auto pt-6 border border-b-0  border-x-0 border-solid border-t-[#141414] ">
                <p className="text-transparent3">{dataDetail?.subTitle}</p>
                <Link to={dataDetail?.seeMoreUrl ?? ""} target="_blank">
                    <button
                        type="button"
                        className="bg-white text-black flex items-center justify-center gap-y-4 mt-4 px-5 py-4 rounded-full w-full leading-[24px] font-medium"
                    >
                        See more
                        <Image
                            src={'/icons/arrow-black.svg'}
                            width={24}
                            height={24}
                            alt=""
                            className="w-5 h-5"
                        />
                    </button>
                </Link>
            </div>
        </div>
    );
}
